export default function MobileMenu() {
  const header = document.querySelector('.o-header')
  const body = document.querySelector('body')
  const burger = document.querySelector('.hamburger')
  const menu = document.querySelector('.m-nav.mobile')

  const links = document.querySelectorAll(
    '.o-header__nav.mobile #menu-main-menu-1 li a'
  )
  links.forEach((link) => {
    link.addEventListener('click', () => {
      if (window.innerWidth < 1024) {
        menu.classList.remove('is-active')
        burger.classList.remove('is-active')
      }
    })
  })

  const handleClick = () => {
    if (menu.classList.contains('is-active')) {
      menu.classList.remove('is-active')
      // $(menu).fadeOut(200)
      burger.classList.remove('is-active')
    } else {
      menu.classList.add('is-active')
      // $(menu).fadeIn(200)
      burger.classList.add('is-active')
    }
    if (header.classList.contains('is-active')) {
      header.classList.remove('is-active')
    } else {
      header.classList.add('is-active')
    }
    if (body.classList.contains('is-active')) {
      body.classList.remove('is-active')
    } else {
      body.classList.add('is-active')
    }
  }
  burger.addEventListener('click', handleClick)

  const firstLevelList = document.querySelectorAll(
    '.o-header__nav.mobile #menu-menu-1 > .menu-item-has-children'
  )
  firstLevelList.forEach((firstLvl) => {
    firstLvl
      .querySelector(
        '.o-header__nav.mobile #menu-menu-1 > .menu-item-has-children > a'
      )
      .addEventListener('click', (e) => {
        if (window.innerWidth < 1024) {
          e.preventDefault()
          firstLvl.classList.toggle('active')
        }
      })
  })

  const secondLevelList = document.querySelectorAll(
    '.o-header__nav.mobile #menu-menu-1 > .menu-item-has-children > ul > .menu-item-has-children'
  )
  secondLevelList.forEach((secondLvl) => {
    secondLvl
      .querySelector(
        '.o-header__nav.mobile #menu-menu-1 > .menu-item-has-children > ul > .menu-item-has-children > a'
      )
      .addEventListener('click', (e) => {
        e.preventDefault()
        secondLvl.classList.toggle('active')
      })
  })
  const thirdLevelList = document.querySelectorAll(
    '.o-header__nav.mobile #menu-menu-1 > .menu-item-has-children > ul > .menu-item-has-children > ul > .menu-item-has-children'
  )
  thirdLevelList.forEach((thirdLvl) => {
    thirdLvl
      .querySelector(
        '.o-header__nav.mobile #menu-menu-1 > .menu-item-has-children > ul > .menu-item-has-children > ul > .menu-item-has-children > a'
      )
      .addEventListener('click', (e) => {
        e.preventDefault()
        thirdLvl.classList.toggle('active')
      })
  })
}
